const initialState = {
    responseUsersList: [],
    responseUser: [],
    responsePermissions: [],
    responseError: [],
    userVisibility: [],
    responseErrorVisibility: [],

    responseHashExportUsers: [],
    responseUpdateReportUsers: [],
    responseCheckReportUsers: [],
    errorHashExportUsers: false,
    errorCheckReportUsers: false,
    errorUpdateReportUsers: false
};

const reducer = (state = initialState, action) => {
    const newState = { ...state };

    switch (action.type) {
        case "USERS_RESPONSE_LIST":
            if (action.value.detail !== undefined) { //si hubo error
                newState.responseUsersList = [];
                newState.responseError = action.value;
            } else { //si NO hubo error
                newState.responseUsersList = action.value;
                newState.responseError = [];
            }
            newState.responseUser = [];
            break;

        case "USER_RESPONSE":
            if (action.value.detail !== undefined) { //si hubo error
                newState.responseUser = [];
                newState.responseError = action.value;
            } else { //si NO hubo error
                newState.responseUser = action.value;
                newState.responseError = [];
            }
            break;
        case "PERMISSIONS_RESPONSE":
            newState.responsePermissions = action.value;
            break;
        case "RESPONSE_DASHBOARD_VISIBILITY":
            if (action.value.detail !== undefined) { //si hubo error
                newState.userVisibility = [];
                newState.responseErrorVisibility = action.value;
            } else { //si NO hubo error
                newState.userVisibility = action.value;
                newState.responseErrorVisibility = [];
            }
            break;
        case 'HASH_EXPORT_USERS_RESPONSE':
            newState.responseHashExportUsers = action.value;
            if (action.value.status !== "OK") {
                newState.errorHashExportUsers = true;
            } else {
                newState.errorHashExportUsers = false;
            }
            break;
        case 'REPORT_EXPORT_USERS_RESPONSE':
            newState.responseCheckReportUsers = action.value;
            if (action.value.status !== "OK") {
                newState.errorCheckReportUsers = true;
            } else {
                newState.errorCheckReportUsers = false;
            }
            break;
        case 'UPDATE_EXPORT_USERS_RESPONSE':
            newState.responseUpdateReportUsers = action.value;
            if (action.value.status !== "OK") {
                newState.errorUpdateReportUsers = true;
            } else {
                newState.errorUpdateReportUsers = false;
            }
            break;
        default:
            return newState;
    }

    return newState;
};

export default reducer;